/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";

import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import {GET_REPORT_TABLE} from '../pages/ReportTable/graphql/report-table.query'
import { humanize } from "uno-js";
// import { data } from "./config/profile-data"

import { tableData } from "./test-data/report-table-data"

import { toast } from "react-hot-toast"

const MODULE_NAME = "ReportService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class ReportService {
    private static instance: ReportService;
    private vapp: VApplication;
    private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): ReportService {
        if (!ReportService.instance) {
            ReportService.instance = new ReportService(props);
        }
        return ReportService.instance;
    }

    async getReport(limit: number, skip: number, filter: any) {
        console.log(`report table service`, limit,skip);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: GET_REPORT_TABLE,
                    variables: {
                        criteria: filter,
                        skip: skip,
                        limit: limit
                    },
                    fetchPolicy: "network-only",
                });
                log.success(MODULE_NAME, "getOnboard Table: ", res?.data);
                if (res) {
                    return res?.data?.getApplicationReportTable
                }

            }
        } catch (err: any) {
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

}
